const isNomeGrupoItau = nameGroup => {
    const nameGroupUpperCaseUnaccented = nameGroup
        ?.toUpperCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

    return nameGroupUpperCaseUnaccented === 'ITAU';
};

export default {
    isNomeGrupoItau
};
